<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-button @click="back">{{`返回[${this.$route.query.username}歌单-${this.$route.query.title}]`}}</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="歌曲名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="fetch">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="recordList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" width="60">
			</el-table-column>
			<el-table-column prop="priority" label="排序" width="80">
			</el-table-column>
			<el-table-column prop="name" label="名称" width="200">
			</el-table-column>
			<el-table-column prop="categoryId" label="分类" width="100" :formatter="formatCategory">
			</el-table-column>
			<el-table-column prop="singerName" label="歌手" width="100">
			</el-table-column>
			<el-table-column prop="fileName" label="文件" width="220">
				<template slot-scope="scope">
					<a :href="scope.row.url" target="_blank" class="buttonText">{{scope.row.fileName}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="fileSize" label="大小" width="100">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="180">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" width="180">
			</el-table-column>
			<el-table-column label="操作" width="250" fixed="right">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :page-count="pageNo" :total="pageTotal" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<input hidden v-model="editForm.albumId" />
				<input hidden v-model="editForm.userId" />
				<el-form-item label="歌曲名" prop="name">
					<span>{{editForm.name}}</span>
				</el-form-item>
				<el-form-item label="歌手" prop="singerName">
					<span>{{editForm.singerName}}</span>
				</el-form-item>
				<el-form-item label="文件名" prop="fileName">
					<span>{{editForm.fileName}}</span>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{editForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="优先级" prop="priority">
					<el-input v-model="editForm.priority" placeholder="999" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<input hidden v-model="addForm.albumId" />
				<input hidden v-model="addForm.userId" />
				<el-form-item label="歌曲名" prop="name">
					<el-autocomplete
						class="el-input"
						v-model="addForm.name"
						:fetch-suggestions="searchMusic"
						placeholder="搜索歌曲名"
						:trigger-on-focus="false"
						@select="handleSelect">
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="歌手" prop="singerName">
					<span>{{addForm.singerName}}</span>
				</el-form-item>
				<el-form-item label="文件名" prop="fileName">
					<span>{{addForm.fileName}}</span>
				</el-form-item>
				<el-form-item label="文件大小" prop="fileSize">
					<span>{{addForm.fileSize}}</span>
				</el-form-item>
				<el-form-item label="优先级" prop="priority">
					<el-input v-model="addForm.priority" placeholder="999" auto-complete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../common/js/util'
	//import NProgress from 'nprogress'
	import { getCategoryList, getMusicList, getAlbumMusicListPage, removeAlbumMusic, batchRemoveAlbumMusic, editAlbumMusic, addAlbumMusic, getMusicListPage } from '../api/api';

	export default {
		data() {
			return {
				filters: {
					name: ''
				},
				recordList: [],
				categorys: [],
				pageTotal: 0,
				currentPage: 1,
				pageSize: 15,
				pageNo: 1,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					name: [
						{ required: true, message: '请输入歌曲名', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					albumId: this.$route.query.albumId,
					userId: this.$route.query.userId,
					musicId: '',
					singerName: '',
					url: '',
					fileName: '',
					fileSize: '0',
					name: '',
					hash: '',
					priority: '999'
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					name: [
						{ required: true, message: '请输入歌曲名', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					albumId: this.$route.query.albumId,
					userId: this.$route.query.userId,
					musicId: '',
					singerName: '',
					url: '',
					fileName: '',
					fileSize: '0',
					name: '',
					hash: '',
					priority: '999'
				}
			}
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetch();
			},
			back() {
				this.$router.back()
			},
			async searchMusic(name, callback) {
				const res = await getMusicList({ name })
				callback(res.data.data.recordList.map(item => {
					return { ...item, value: item.name };
				}))
			},
			//分类显示转换
			formatCategory: function (row, column) {
				const arr = this.categorys.filter(item => item._id === row.categoryId);
				if (arr && arr.length > 0) {
					return arr[0].name;
				} else {
					return '';
				}
			},
			//获取用户列表
			async fetch() {
				const para = {
					albumId: this.$route.query.albumId,
					name: this.filters.name,
					currentPage: this.currentPage,
					pageSize: this.pageSize,
				};
				this.listLoading = true;
				//NProgress.start();
				const res = await getAlbumMusicListPage(para)
				this.listLoading = false;
				//NProgress.done();
				if (res.data.status !== 200) {
					this.$message({
					message: res.data.message,
					type: 'warning'
					});
					return
				}
				this.currentPage = res.data.data.currentPage;
				this.pageSize = res.data.data.pageSize;
				this.pageNo = res.data.data.pageNo;
				this.pageTotal = res.data.data.pageTotal;
				this.recordList = res.data.data.recordList;
			},
			//获取分类列表
			async getCateList() {
				const res = await getCategoryList()
				this.categorys = res.data.data.recordList;
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					albumId: this.$route.query.albumId,
					userId: this.$route.query.userId,
					musicId: '',
					singerName: '',
					url: '',
					fileName: '',
					fileSize: '0',
					name: '',
					hash: '',
					priority: '999'
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate(async (valid) => {
					if (valid) {
						this.editLoading = true;
						//NProgress.start();
						const para = Object.assign({}, this.editForm);
						const res = await editAlbumMusic(para)
						this.editLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['editForm'].resetFields();
						this.editFormVisible = false;
						this.fetch();
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate(async (valid) => {
					if (valid) {
						this.addLoading = true;
						//NProgress.start();
						let para = Object.assign({}, this.addForm);
						const res = await addAlbumMusic(para)
						this.addLoading = false;
						//NProgress.done();
						if (res.data.status !== 200) {
							this.$message({
							message: res.data.message,
							type: 'warning'
							});
							return
						}
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.$refs['addForm'].resetFields();
						this.addFormVisible = false;
						this.fetch();
					}
				});
			},
			handleSelect(item) {
				if (this.addFormVisible) {
					this.addForm.musicId = item._id
					this.addForm.singerId = item.singerId
					this.addForm.categoryId = item.categoryId
					this.addForm.singerName = item.singerName
					this.addForm.url = item.url
					this.addForm.fileName = item.fileName
					this.addForm.fileSize = item.fileSize
					this.addForm.name = item.name
					this.addForm.hash = item.hash
				} else if (this.editFormVisible) {
					this.editForm.musicId = item._id
					this.editForm.singerId = item.singerId
					this.editForm.categoryId = item.categoryId
					this.editForm.singerName = item.singerName
					this.editForm.url = item.url
					this.editForm.fileName = item.fileName
					this.editForm.fileSize = item.fileSize
					this.editForm.name = item.name
					this.editForm.hash = item.hash
				}
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					const para = { id: row._id };
					const res = await removeAlbumMusic(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				const ids = this.sels.map(item => item._id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(async () => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					const res = await batchRemoveAlbumMusic(para)
					this.listLoading = false;
					//NProgress.done();
					if (res.data.status !== 200) {
						this.$message({
						message: res.data.message,
						type: 'warning'
						});
						return
					}
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.fetch();
				}).catch(() => {

				});
			}
		},
		async mounted() {
			await this.getCateList();
			this.fetch();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AlbumMusic.vue?0a31090f